import { TFunction } from 'react-i18next';

const getFormYesNoOptions = (tForm: TFunction) => [
  { label: tForm('yes'), value: 'yes' },
  { label: tForm('no'), value: 'no' },
];

export default getFormYesNoOptions;
